var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurityAndLoginPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 930,
    height: 650,
    viewBox: "0 0 930 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1175",
    "data-name": "Rectangle 1175",
    width: 930,
    height: 650,
    transform: "translate(1135 380.765)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M163.72,243.192l-54.3-17.727L104.588,212.7l-11.032-.346-20.019-3.793,2.408,4.139,25.2,18.287,6.217,3.1,56.791,29.665Z",
    transform: "translate(-73.537 -208.563)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1.086
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M99.243,212.345l-5.178-3.1-10.339,3.793,1.715,2.061Z",
    transform: "translate(-83.726 -209.245)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1.086
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M146.884,157.127s-.841,7.42,1.253,12.186,13.72,20.909,13.72,20.909l-21.7,17.4s-9-18.139-10.718-21.074-3.776-15.566,1.814-24.619S144.889,150.432,146.884,157.127Z",
    transform: "translate(-127.604 -153.312)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1.086
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M166.233,155.294c-1.336-8.245-10.784-25.015-25.774-24.372-9.729.429-14.28,2.391-18.5,4.782a54.415,54.415,0,0,0-9.564,7.157c-7.321,8.789-9.894,11.2-8.476,17.924a20.183,20.183,0,0,0,1.237,7.882c2.243,5.986,3.776,9.894,5.722,12.747-.594,2.787-2.144,10.141-2.226,11.823s4.947.511,7.486-.132c4.716,10.553,13.357,17.875,16.045,18.716,4.683,1.468,12.087-6.233,16.012-12.2s.956-12.681.973-15.352,8.822-8.542,12.087-10.405S167.552,163.522,166.233,155.294Z",
    transform: "translate(-103.544 -130.904)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1.082
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M201.4,185.536s11.691,7.965,11.955,26.779c.115,8.245-.742,15.946-2.638,29.451s-13.67,57.484-22.838,62.826-23.4-4.749-23.4-4.749L95.652,254.15,79.013,240.711l-8.245-15.566,2.589-4.947,20.3,15.566L82.724,225.656l2.144-2.721,3.958,2.754,11.543,4.32,2.523,16.49,3.562,2.44L172.3,273s-.824-35.437-.214-42.214,1.451-23.811,8.707-36.162",
    transform: "translate(-70.769 -185.536)",
    fill: "#fff",
    stroke: "#4b4e6d",
    strokeWidth: 1.086
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security_and_login_phone",
    transform: "translate(-1135 -380.765)",
    opacity: 0.2,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_login-bro",
    "data-name": "Mobile login-bro",
    transform: "translate(1265.373 381.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-87",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M649.269,144.984c-41.027-93.547-139.5-128.769-217.2-65.959-30.341,24.5-49.272,63.5-86.423,79.151-34.86,14.676-79.019,10.356-116.715,18.3C148.654,193.3,40.58,257.115,48.825,355.444c3.611,43.071,32.666,90.908,47.029,131.21,16.49,46.369,26.384,104.381,70.032,132.1,74.831,47.59,165.1,8.69,232.507-29.682,36.278-20.629,56.247-33.31,95.311-26.235,36.162,6.6,68.73,29.682,104.067,2.292,26.532-20.563,28.725-62.233,51-86.7,25.1-27.571,50.541-29.566,63.585-71.005,15.814-50.278-7.486-81.691-23.234-126.609S668.6,189,649.269,144.984Z",
    transform: "translate(-48.38 -47.391)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M649.269,144.984c-41.027-93.547-139.5-128.769-217.2-65.959-30.341,24.5-49.272,63.5-86.423,79.151-34.86,14.676-79.019,10.356-116.715,18.3C148.654,193.3,40.58,257.115,48.825,355.444c3.611,43.071,32.666,90.908,47.029,131.21,16.49,46.369,26.384,104.381,70.032,132.1,74.831,47.59,165.1,8.69,232.507-29.682,36.278-20.629,56.247-33.31,95.311-26.235,36.162,6.6,68.73,29.682,104.067,2.292,26.532-20.563,28.725-62.233,51-86.7,25.1-27.571,50.541-29.566,63.585-71.005,15.814-50.278-7.486-81.691-23.234-126.609S668.6,189,649.269,144.984Z",
    transform: "translate(-48.38 -47.391)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1--inject-87",
    transform: "translate(33.804 617.716)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 254.9,
    cy: 15.88,
    rx: 254.9,
    ry: 15.88,
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 254.9,
    cy: 15.88,
    rx: 254.9,
    ry: 15.88,
    fill: "#fff",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1--inject-87",
    transform: "translate(191.908 29.754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1224",
    "data-name": "Rectangle 1224",
    width: 320.381,
    height: 605.177,
    rx: 21.015,
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1225",
    "data-name": "Rectangle 1225",
    width: 290.379,
    height: 471.132,
    transform: "translate(15.755 67.592)",
    fill: "#fff",
    stroke: "#4b4e6d",
    strokeWidth: 1.447
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 63.272,
    cy: 63.272,
    r: 63.272,
    transform: "translate(70.713 212.949) rotate(-45)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M391.952,402.741H225.834a2.836,2.836,0,0,1-2.853-2.836h0a2.836,2.836,0,0,1,2.853-2.853H391.952a2.836,2.836,0,0,1,2.836,2.853h0A2.836,2.836,0,0,1,391.952,402.741Z",
    transform: "translate(-148.694 106.284)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1226",
    "data-name": "Rectangle 1226",
    width: 190.177,
    height: 34.084,
    rx: 4.337,
    transform: "translate(65.102 311.79)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1227",
    "data-name": "Rectangle 1227",
    width: 190.177,
    height: 34.084,
    rx: 4.337,
    transform: "translate(65.102 375.54)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M324.133,254.83l-18.617-10.718v-8.855a29.119,29.119,0,0,0,5.722-11.164,6,6,0,0,0,2,.346c2.309,0,3.776-7.157,4.023-12.268,2.688-5.689-.973-9.02-.973-9.02s1.517-1.517,2.523-7.6-3.545-3.545-7.091-9.119-6.085-11.642-17.727-11.642a16,16,0,0,0-15.2,9.63,38.52,38.52,0,0,0-8.608,1.006c-3.562,1.006-4.568,12.664-1.534,17.232a17.365,17.365,0,0,1,2.111,8.129c-.808-.989-1.649-1.253-2.111.989-1.006,5.062,3.051,12.153,3.051,12.153l2.094-.594a29.681,29.681,0,0,0,5.953,11.922v8.855L261.125,254.83a14.313,14.313,0,0,0-7.157,12.384v6.134a63.239,63.239,0,0,0,77.321,0v-6.134A14.28,14.28,0,0,0,324.133,254.83Z",
    transform: "translate(-132.438 -10.319)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 9.148,
    cy: 9.148,
    r: 9.148,
    transform: "translate(83.367 383.966)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 9.148,
    cy: 9.148,
    r: 9.148,
    transform: "translate(110.09 383.966)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 9.148,
    cy: 9.148,
    r: 9.148,
    transform: "translate(136.853 383.966)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 9.148,
    cy: 9.148,
    r: 9.148,
    transform: "translate(163.607 383.966)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 9.148,
    cy: 9.148,
    r: 9.148,
    transform: "translate(190.354 383.966)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 9.148,
    cy: 9.148,
    r: 9.148,
    transform: "translate(217.072 383.966)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1228",
    "data-name": "Rectangle 1228",
    width: 290.379,
    height: 18.913,
    transform: "translate(15.755 66.455)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M323.473,91.783H259.987a4.32,4.32,0,0,1-4.32-4.32h0a4.32,4.32,0,0,1,4.32-4.32h63.486a4.32,4.32,0,0,1,4.32,4.32h0a4.32,4.32,0,0,1-4.32,4.32Z",
    transform: "translate(-131.548 -58.391)",
    fill: "#09f",
    stroke: "#4b4e6d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.447
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M302.593,443.727a17.314,17.314,0,1,0-17.3,17.3A17.314,17.314,0,0,0,302.593,443.727Z",
    transform: "translate(-125.096 121.677)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1229",
    "data-name": "Rectangle 1229",
    width: 17.545,
    height: 17.545,
    transform: "translate(151.426 556.631)",
    fill: "#09f",
    stroke: "#4b4e6d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.447
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1--inject-87",
    transform: "translate(486.065 318.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M442.231,333.728s-22.987-58.407-2.523-65.349c21.3-7.239,20.365,31.331,19.541,50.129-1.731,40.169-6.167,47.639-9.482,37.828Zm-6.909,45.561c6.316,8.245,8.1-.3-3.3-38.867-5.343-18.139-16.952-54.829-34.761-41.06-17.1,13.192,23.6,61.012,23.6,61.012Zm-12.2,33.474c6.019,5.343,6.134-1.4-8.162-29.253-6.711-13.044-20.909-39.444-32.534-26.384-11.164,12.6,26.878,43.22,26.878,43.22Zm-13.192,39.806c6.019,5.359,6.134-1.4-8.162-29.236-6.711-13.043-20.909-39.46-32.534-26.384-11.1,12.631,26.829,43.253,26.829,43.253Zm38.091-81.031c-9.63,3.76-1.979,7.849,38.24,7.734,18.864,0,57.385-.857,49.173-21.816-7.866-20.134-65.151,5.508-65.151,5.508Zm-10.966,26.78c-10.191,1.764-3.5,7.3,35.948,15.187,18.485,3.71,56.4,10.553,52.52-11.543-3.71-21.3-64.954-7.552-64.954-7.552Zm-12.268,32.7c-8.674,1.253-3.133,6.085,30.028,13.67,15.55,3.562,47.458,10.24,44.687-8.608-2.638-18.139-54.746-7.882-54.746-7.882Zm-9.317,30.292c-8.492,2.16-2.474,6.382,31.331,10.405,15.83,1.88,48.266,5.145,43.533-13.307-4.568-17.71-55.29-2.028-55.29-2.028Zm49.7-122.635c-4.947,11.081,5.326,9.4,40.252-21.074,16.358-14.3,49.173-44.209,23.185-59.1-24.949-14.313-51.778,54.746-51.778,54.746Zm-48.414,162.1c-5.227,3.051-.1,4.238,23.877-.544,11.246-2.226,34.117-7.173,26.384-16.935-7.486-9.4-38.157,10.389-38.157,10.389Z",
    transform: "translate(-367.196 -256.549)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M442.231,333.728s-22.987-58.407-2.523-65.349c21.3-7.239,20.365,31.331,19.541,50.129-1.731,40.169-6.167,47.639-9.482,37.828Zm-6.909,45.561c6.316,8.245,8.1-.3-3.3-38.867-5.343-18.139-16.952-54.829-34.761-41.06-17.1,13.192,23.6,61.012,23.6,61.012Zm-12.2,33.474c6.019,5.343,6.134-1.4-8.162-29.253-6.711-13.044-20.909-39.444-32.534-26.384-11.164,12.6,26.878,43.22,26.878,43.22Zm-13.192,39.806c6.019,5.359,6.134-1.4-8.162-29.236-6.711-13.043-20.909-39.46-32.534-26.384-11.1,12.631,26.829,43.253,26.829,43.253Zm38.091-81.031c-9.63,3.76-1.979,7.849,38.24,7.734,18.864,0,57.385-.857,49.173-21.816-7.866-20.134-65.151,5.508-65.151,5.508Zm-10.966,26.78c-10.191,1.764-3.5,7.3,35.948,15.187,18.485,3.71,56.4,10.553,52.52-11.543-3.71-21.3-64.954-7.552-64.954-7.552Zm-12.268,32.7c-8.674,1.253-3.133,6.085,30.028,13.67,15.55,3.562,47.458,10.24,44.687-8.608-2.638-18.139-54.746-7.882-54.746-7.882Zm-9.317,30.292c-8.492,2.16-2.474,6.382,31.331,10.405,15.83,1.88,48.266,5.145,43.533-13.307-4.568-17.71-55.29-2.028-55.29-2.028Zm49.7-122.635c-4.947,11.081,5.326,9.4,40.252-21.074,16.358-14.3,49.173-44.209,23.185-59.1-24.949-14.313-51.778,54.746-51.778,54.746Zm-48.414,162.1c-5.227,3.051-.1,4.238,23.877-.544,11.246-2.226,34.117-7.173,26.384-16.935-7.486-9.4-38.157,10.389-38.157,10.389Z",
    transform: "translate(-367.196 -256.549)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M443.639,352.216l-4.007-66.668m-8.674,88.666L405.63,316.878m90.694,40.664-60.7,8.707m-17.793,38.867-32.864-42.165M423.6,392.187l45.281,2.276m-56,30.061,34.629,3.43M404.525,445.07l-17.2-25.873m15.22,35.008,40.713.379m-48.958,76a1.039,1.039,0,0,0,.956-1.1c-2.589-38.883,12.45-102.567,36.574-154.84,15.418-33.408,75.853-99.071,76.5-99.73a1.039,1.039,0,0,0,0-1.468,1.022,1.022,0,0,0-1.451,0c-.61.66-61.293,66.569-76.843,100.275-24.57,53.543-39.411,116.072-36.772,155.895a1.055,1.055,0,0,0,1.039.973Zm49.321-177.348a1.039,1.039,0,0,0,.973-1.088l-3.941-66.7a1.022,1.022,0,0,0-1.088-.973,1.039,1.039,0,0,0-.973,1.088l4.007,66.668a1.022,1.022,0,0,0,1.022.973Zm-12.3,21.915a1.039,1.039,0,0,0,.528-1.352L406.5,316.466a1.026,1.026,0,1,0-1.88.824l25.328,57.335a1.039,1.039,0,0,0,.94.627,1.022,1.022,0,0,0,.495-.1Zm4.386-7.915,60.666-8.674a1.039,1.039,0,1,0-.28-2.045l-60.666,8.674a1.024,1.024,0,1,0,.132,2.045Zm-17.3,38.7a1.039,1.039,0,0,0,.181-1.451L385.71,362.242a1.041,1.041,0,1,0-1.649,1.27l32.947,42.313a1.023,1.023,0,0,0,.808.4,1.039,1.039,0,0,0,.66-.28Zm51.382-11.427a1.039,1.039,0,0,0-.989-1.072l-45.2-2.292a1.039,1.039,0,0,0-.1,2.061l45.281,2.292h0a1.039,1.039,0,0,0,1.072-.989Zm-21.321,33.54a1.022,1.022,0,0,0-.923-1.138L412.918,423.5a1.022,1.022,0,0,0-1.121.923,1.039,1.039,0,0,0,.923,1.121l34.629,3.43h.1a1.022,1.022,0,0,0,1.088-.923ZM405.02,445.928a1.039,1.039,0,0,0,.3-1.435L388.2,418.62a1.055,1.055,0,0,0-1.435-.28,1.039,1.039,0,0,0-.3,1.435l17.116,25.873a1.072,1.072,0,0,0,.874.462.989.989,0,0,0,.627-.181Zm39.279,8.657a1.055,1.055,0,0,0-1.022-1.039l-40.713-.379h0a1.022,1.022,0,0,0-1.022,1.022,1.006,1.006,0,0,0,1.022,1.039l40.713.379h0a1.039,1.039,0,0,0,1.088-1.022Zm-54.631,60.881c.082-.181,7.025-19.31,27.9-23.877a1.039,1.039,0,0,0,.792-1.237,1.055,1.055,0,0,0-1.237-.775c-22.014,4.815-29.319,25.015-29.4,25.213a1.055,1.055,0,0,0,.643,1.319h.33a1.022,1.022,0,0,0,1.039-.643Zm4.634,15.121a1.039,1.039,0,0,0,.956-1.1c-2.589-38.883,12.45-102.567,36.574-154.84,15.418-33.408,75.853-99.071,76.5-99.73a1.039,1.039,0,0,0,0-1.468,1.022,1.022,0,0,0-1.451,0c-.61.66-61.293,66.569-76.843,100.275-24.57,53.543-39.411,116.072-36.772,155.895a1.055,1.055,0,0,0,1.039.973Zm49.321-177.348a1.039,1.039,0,0,0,.973-1.088l-3.941-66.7a1.022,1.022,0,0,0-1.088-.973,1.039,1.039,0,0,0-.973,1.088l4.007,66.668a1.022,1.022,0,0,0,1.022.973Zm-12.3,21.915a1.039,1.039,0,0,0,.528-1.352L406.5,316.466a1.026,1.026,0,1,0-1.88.824l25.328,57.335a1.039,1.039,0,0,0,.94.627,1.022,1.022,0,0,0,.495-.1Zm4.386-7.915,60.666-8.674a1.039,1.039,0,1,0-.28-2.045l-60.666,8.674a1.024,1.024,0,0,0,.132,2.045Zm-17.3,38.7a1.039,1.039,0,0,0,.181-1.451L385.71,362.242a1.041,1.041,0,0,0-1.649,1.27l32.947,42.313a1.023,1.023,0,0,0,.808.4,1.039,1.039,0,0,0,.66-.28Zm51.382-11.427a1.039,1.039,0,0,0-.989-1.072l-45.2-2.292a1.039,1.039,0,0,0-.1,2.061l45.281,2.292h0a1.039,1.039,0,0,0,1.072-.989Zm-21.321,33.54a1.022,1.022,0,0,0-.923-1.138L412.918,423.5a1.023,1.023,0,0,0-1.121.923,1.039,1.039,0,0,0,.923,1.121l34.629,3.43h.1a1.022,1.022,0,0,0,1.088-.923ZM405.02,445.928a1.039,1.039,0,0,0,.3-1.435L388.2,418.62a1.055,1.055,0,0,0-1.435-.28,1.039,1.039,0,0,0-.3,1.435l17.117,25.873a1.072,1.072,0,0,0,.874.462.99.99,0,0,0,.626-.181Zm39.279,8.657a1.055,1.055,0,0,0-1.022-1.039l-40.713-.379h0a1.022,1.022,0,0,0-1.022,1.022,1.006,1.006,0,0,0,1.022,1.039l40.713.379h0a1.039,1.039,0,0,0,1.088-1.022Zm-54.631,60.881c.082-.181,7.025-19.31,27.9-23.877a1.039,1.039,0,0,0,.792-1.237,1.055,1.055,0,0,0-1.237-.775c-22.014,4.815-29.319,25.015-29.4,25.213a1.055,1.055,0,0,0,.643,1.319h.33a1.022,1.022,0,0,0,1.039-.643Z",
    transform: "translate(-358.463 -247.845)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M443.639,352.216l-4.007-66.668m-8.674,88.666L405.63,316.878m90.694,40.664-60.7,8.707m-17.793,38.867-32.864-42.165M423.6,392.187l45.281,2.276m-56,30.061,34.629,3.43M404.525,445.07l-17.2-25.873m15.22,35.008,40.713.379m-48.958,76a1.039,1.039,0,0,0,.956-1.1c-2.589-38.883,12.45-102.567,36.574-154.84,15.418-33.408,75.853-99.071,76.5-99.73a1.039,1.039,0,0,0,0-1.468,1.022,1.022,0,0,0-1.451,0c-.61.66-61.293,66.569-76.843,100.275-24.57,53.543-39.411,116.072-36.772,155.895a1.055,1.055,0,0,0,1.039.973Zm49.321-177.348a1.039,1.039,0,0,0,.973-1.088l-3.941-66.7a1.022,1.022,0,0,0-1.088-.973,1.039,1.039,0,0,0-.973,1.088l4.007,66.668a1.022,1.022,0,0,0,1.022.973Zm-12.3,21.915a1.039,1.039,0,0,0,.528-1.352L406.5,316.466a1.026,1.026,0,1,0-1.88.824l25.328,57.335a1.039,1.039,0,0,0,.94.627,1.022,1.022,0,0,0,.495-.1Zm4.386-7.915,60.666-8.674a1.039,1.039,0,1,0-.28-2.045l-60.666,8.674a1.024,1.024,0,1,0,.132,2.045Zm-17.3,38.7a1.039,1.039,0,0,0,.181-1.451L385.71,362.242a1.041,1.041,0,1,0-1.649,1.27l32.947,42.313a1.023,1.023,0,0,0,.808.4,1.039,1.039,0,0,0,.66-.28Zm51.382-11.427a1.039,1.039,0,0,0-.989-1.072l-45.2-2.292a1.039,1.039,0,0,0-.1,2.061l45.281,2.292h0a1.039,1.039,0,0,0,1.072-.989Zm-21.321,33.54a1.022,1.022,0,0,0-.923-1.138L412.918,423.5a1.022,1.022,0,0,0-1.121.923,1.039,1.039,0,0,0,.923,1.121l34.629,3.43h.1a1.022,1.022,0,0,0,1.088-.923ZM405.02,445.928a1.039,1.039,0,0,0,.3-1.435L388.2,418.62a1.055,1.055,0,0,0-1.435-.28,1.039,1.039,0,0,0-.3,1.435l17.116,25.873a1.072,1.072,0,0,0,.874.462.989.989,0,0,0,.627-.181Zm39.279,8.657a1.055,1.055,0,0,0-1.022-1.039l-40.713-.379h0a1.022,1.022,0,0,0-1.022,1.022,1.006,1.006,0,0,0,1.022,1.039l40.713.379h0a1.039,1.039,0,0,0,1.088-1.022Zm-54.631,60.881c.082-.181,7.025-19.31,27.9-23.877a1.039,1.039,0,0,0,.792-1.237,1.055,1.055,0,0,0-1.237-.775c-22.014,4.815-29.319,25.015-29.4,25.213a1.055,1.055,0,0,0,.643,1.319h.33a1.022,1.022,0,0,0,1.039-.643Zm4.634,15.121a1.039,1.039,0,0,0,.956-1.1c-2.589-38.883,12.45-102.567,36.574-154.84,15.418-33.408,75.853-99.071,76.5-99.73a1.039,1.039,0,0,0,0-1.468,1.022,1.022,0,0,0-1.451,0c-.61.66-61.293,66.569-76.843,100.275-24.57,53.543-39.411,116.072-36.772,155.895a1.055,1.055,0,0,0,1.039.973Zm49.321-177.348a1.039,1.039,0,0,0,.973-1.088l-3.941-66.7a1.022,1.022,0,0,0-1.088-.973,1.039,1.039,0,0,0-.973,1.088l4.007,66.668a1.022,1.022,0,0,0,1.022.973Zm-12.3,21.915a1.039,1.039,0,0,0,.528-1.352L406.5,316.466a1.026,1.026,0,1,0-1.88.824l25.328,57.335a1.039,1.039,0,0,0,.94.627,1.022,1.022,0,0,0,.495-.1Zm4.386-7.915,60.666-8.674a1.039,1.039,0,1,0-.28-2.045l-60.666,8.674a1.024,1.024,0,0,0,.132,2.045Zm-17.3,38.7a1.039,1.039,0,0,0,.181-1.451L385.71,362.242a1.041,1.041,0,0,0-1.649,1.27l32.947,42.313a1.023,1.023,0,0,0,.808.4,1.039,1.039,0,0,0,.66-.28Zm51.382-11.427a1.039,1.039,0,0,0-.989-1.072l-45.2-2.292a1.039,1.039,0,0,0-.1,2.061l45.281,2.292h0a1.039,1.039,0,0,0,1.072-.989Zm-21.321,33.54a1.022,1.022,0,0,0-.923-1.138L412.918,423.5a1.023,1.023,0,0,0-1.121.923,1.039,1.039,0,0,0,.923,1.121l34.629,3.43h.1a1.022,1.022,0,0,0,1.088-.923ZM405.02,445.928a1.039,1.039,0,0,0,.3-1.435L388.2,418.62a1.055,1.055,0,0,0-1.435-.28,1.039,1.039,0,0,0-.3,1.435l17.117,25.873a1.072,1.072,0,0,0,.874.462.99.99,0,0,0,.626-.181Zm39.279,8.657a1.055,1.055,0,0,0-1.022-1.039l-40.713-.379h0a1.022,1.022,0,0,0-1.022,1.022,1.006,1.006,0,0,0,1.022,1.039l40.713.379h0a1.039,1.039,0,0,0,1.088-1.022Zm-54.631,60.881c.082-.181,7.025-19.31,27.9-23.877a1.039,1.039,0,0,0,.792-1.237,1.055,1.055,0,0,0-1.237-.775c-22.014,4.815-29.319,25.015-29.4,25.213a1.055,1.055,0,0,0,.643,1.319h.33a1.022,1.022,0,0,0,1.039-.643Z",
    transform: "translate(-358.463 -247.845)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M424.429,422.935H377.746V432.6h4.073l8.426,52.718h21.684l8.426-52.718h4.073Z",
    transform: "translate(-361.662 -169.264)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M424.429,422.935H377.746V432.6h4.073l8.426,52.718h21.684l8.426-52.718h4.073Z",
    transform: "translate(-361.662 -169.264)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-87",
    transform: "translate(25.691 115.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M163.72,243.192l-54.3-17.727L104.588,212.7l-11.032-.346-20.019-3.793,2.408,4.139,25.2,18.287,6.217,3.1,56.791,29.665Z",
    transform: "translate(-60.874 -78.623)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M99.243,212.345l-5.178-3.1-10.339,3.793,1.715,2.061Z",
    transform: "translate(-55.529 -78.266)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M163.72,243.192l-54.3-17.727L104.588,212.7l-11.032-.346-20.019-3.793,2.408,4.139,25.2,18.287,6.217,3.1,56.791,29.665Z",
    transform: "translate(-60.874 -78.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(12.664 129.94)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M163.72,243.192l-54.3-17.727L104.588,212.7l-11.032-.346-20.019-3.793,2.408,4.139,25.2,18.287,6.217,3.1,56.791,29.665Z",
    transform: "translate(-73.537 -208.563)",
    fill: "#09f",
    stroke: "#263238",
    strokeWidth: 1.086,
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M163.72,243.192l-54.3-17.727L104.588,212.7l-11.032-.346-20.019-3.793,2.408,4.139,25.2,18.287,6.217,3.1,56.791,29.665Z",
    transform: "translate(-60.874 -78.623)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M99.243,212.345l-5.178-3.1-10.339,3.793,1.715,2.061Z",
    transform: "translate(-55.529 -78.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(28.197 130.979)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M99.243,212.345l-5.178-3.1-10.339,3.793,1.715,2.061Z",
    transform: "translate(-83.726 -209.245)",
    fill: "#09f",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1.086,
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M99.243,212.345l-5.178-3.1-10.339,3.793,1.715,2.061Z",
    transform: "translate(-55.529 -78.266)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M146.884,157.127s-.841,7.42,1.253,12.186,13.72,20.909,13.72,20.909l-21.7,17.4s-9-18.139-10.718-21.074-3.776-15.566,1.814-24.619S144.889,150.432,146.884,157.127Z",
    transform: "translate(-32.511 -107.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(95.093 45.705)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M134.68,171.454l9.416,19.524-5.013,7.14-9.465-16.9Z",
    transform: "translate(-126.548 -143.795)",
    fill: "#09f",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M146.884,157.127s-.841,7.42,1.253,12.186,13.72,20.909,13.72,20.909l-21.7,17.4s-9-18.139-10.718-21.074-3.776-15.566,1.814-24.619S144.889,150.432,146.884,157.127Z",
    transform: "translate(-32.511 -107.607)",
    fill: "none",
    stroke: "#4b4e6d",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M166.233,155.294c-1.336-8.245-10.784-25.015-25.774-24.372-9.729.429-14.28,2.391-18.5,4.782a54.415,54.415,0,0,0-9.564,7.157c-7.321,8.789-9.894,11.2-8.476,17.924a20.183,20.183,0,0,0,1.237,7.882c2.243,5.986,3.776,9.894,5.722,12.747-.594,2.787-2.144,10.141-2.226,11.823s4.947.511,7.486-.132c4.716,10.553,13.357,17.875,16.045,18.716,4.683,1.468,12.087-6.233,16.012-12.2s.956-12.681.973-15.352,8.822-8.542,12.087-10.405S167.552,163.522,166.233,155.294Z",
    transform: "translate(-45.132 -119.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(58.412 11.542)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M103.965,158.112a20.184,20.184,0,0,0,1.237,7.882c2.243,5.986,3.776,9.894,5.722,12.747-.594,2.787-2.144,10.141-2.226,11.823s4.947.511,7.486-.132c4.716,10.554,13.357,17.875,16.045,18.716,4.683,1.468,12.087-6.233,16.012-12.2A12.021,12.021,0,0,0,150.1,192c-.214-.775-.363-1.253-.363-1.253s-2.21,8.492-6.6,7.387-11.1-9.894-14.841-12.928-2.21-7.025-2.952-11.543-11.823-8.492-12.565-11.081,1.847-13.307,1.847-13.307,4.2-5.607,3.3-3.3a15.7,15.7,0,0,0,1.1,12.186,8.41,8.41,0,0,0,7.767,4.8l4.024-19.936L122.335,136l-9.894,4.122C105.054,148.977,102.531,151.384,103.965,158.112Z",
    transform: "translate(-103.525 -128.231)",
    fill: "#09f",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M166.233,155.294c-1.336-8.245-10.784-25.015-25.774-24.372-9.729.429-14.28,2.391-18.5,4.782a54.415,54.415,0,0,0-9.564,7.157c-7.321,8.789-9.894,11.2-8.476,17.924a20.183,20.183,0,0,0,1.237,7.882c2.243,5.986,3.776,9.894,5.722,12.747-.594,2.787-2.144,10.141-2.226,11.823s4.947.511,7.486-.132c4.716,10.553,13.357,17.875,16.045,18.716,4.683,1.468,12.087-6.233,16.012-12.2s.956-12.681.973-15.352,8.822-8.542,12.087-10.405S167.552,163.522,166.233,155.294Z",
    transform: "translate(-45.132 -119.362)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1.082
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M109.7,160.768l1.649,4.716s3.545,1.171,7.866-3.545",
    transform: "translate(-41.906 -103.696)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1.082
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M117.688,177.249s3.925-.4,5.508-5.9",
    transform: "translate(-37.713 -98.147)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1.082
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M107.889,159.4s1.171-3.545,8.245-3.545",
    transform: "translate(-42.853 -106.272)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1.082
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M151.114,128.33a117.175,117.175,0,0,0-15.517-1.187s-15.533-8.954-30.457.594-7.75,26.268-7.75,30.44-4.782,4.188-1.8,9.564,13.076,2.408,13.076,2.408a14.346,14.346,0,0,1,5.392-10.471c5.376-4.172,9.663-5.079,11.444-3.875,0,0-1.187,8.954.594,12.532,0,0,5.969,2.985,7.767,2.985s-1.171,2.523,4.782,4.766a7.453,7.453,0,0,0,6.6-.775c.874-3.628,2.787-9.086,6.349-7.816,5.227,1.863,9.993,14.725,2.919,19.112,8.509,1.55,18.815-13.505,19.425-27.225S159.953,129.88,151.114,128.33Z",
    transform: "translate(-49.818 -123.334)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M115.049,140.959s4.386-2.358,9.762,2.688,15.83,11.79,29.682,8.08",
    transform: "translate(-39.097 -114.377)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M114.649,139.742s3.018-4.716,8.064-4.716,16.836,7.074,26.252,7.074",
    transform: "translate(-39.307 -117.2)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M117.26,145.308s-5.722-7.058-11.1-1.336S104.2,155.1,104.2,155.1",
    transform: "translate(-45.349 -113.681)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M97.4,154.6a17.479,17.479,0,0,0,5.706-11.444c.676-7.4,10.784-13.8,17.166-7.734",
    transform: "translate(-48.357 -118.259)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M104.233,130.762s10.108-9.762,18.518,2.688",
    transform: "translate(-44.771 -121.346)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M176.892,444.329s6.217,9.663,5.524,15.88l-.676,6.217s-22.805,6.25-27.637,6.25-30.407-2.424-30.407-2.424l-1.1-4.386a1.451,1.451,0,0,1,.792-1.649l22.805-10.636,7.19-7.866Z",
    transform: "translate(-35.162 45.057)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M157.444,461.694c6.184.478,17.924-3.3,24.735-5.706l-.478,4.32s-22.888,6.25-27.719,6.25-30.407-2.424-30.407-2.424L122.782,461C126.872,461.018,149.265,461.067,157.444,461.694Z",
    transform: "translate(-35.04 51.174)",
    fill: "#09f",
    stroke: "#263238",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M149.931,450.649l-33.194,14.445s-2.836,7.107,0,8.525,64.673,0,64.673,0,4.271-11.23-2.473-18.766S149.931,450.649,149.931,450.649Z",
    transform: "translate(-38.873 47.988)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M181.411,467.04s-61.837,1.418-64.673,0c-1.369-.693-1.418-2.688-1.1-4.584H182.5a25.144,25.144,0,0,1-1.088,4.584Z",
    transform: "translate(-38.874 54.566)",
    fill: "#09f",
    stroke: "#263238",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M133.5,287.816s-8.674,38.438-11.955,62.48-5.211,72.209-4.518,77.733,35.222,98.082,35.222,98.082l3.446,8.245,24.174-4.832s-11.048-35.222-15.187-54.565-13.192-51.119-13.192-56.643,21.437-111.026,22.97-117.952,8.492-17.562,8.492-17.562l-46.287-.94Z",
    transform: "translate(-38.136 -40.171)",
    fill: "#09f",
    stroke: "#263238",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M128.98,289.863S123.9,324.97,126,349.375s6.6,76.364,6.6,84.1,12.483,53.922,13.192,68.433c1.1,20.959-.445,31.331-.445,31.331l-.742,7.6s14.561,2.078,17.743,2.985a39.41,39.41,0,0,0,11.263,1.22s5.293-23.3,5.293-43.154-4.4-60.716-6.6-77.271,4.716-80.421,8.641-92.343,12.5-37.168,6.728-50.063S128.98,289.863,128.98,289.863Z",
    transform: "translate(-33.62 -42.219)",
    fill: "#09f",
    stroke: "#4b4e6d",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M194.887,276.509l-.528,15.7s-9.4,1.863-22.063,4.057c-10.455,1.814-36.706-.478-45.545-1.336a3.067,3.067,0,0,1-2.787-3.3l.857-14.181Z",
    transform: "translate(-34.425 -42.98)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M157.93,173.866S143.089,189.91,137.5,199.887s-7.8,25.262-9.894,37.3,3.578,40.3,1.979,53.279l-5.062,40.878s-1.088,2.77,2.556,5.8,21.437,4.139,37.514,4.947c5.87.3,23.4-3.479,26.268-3.661,3.463-.214,3.578-4.617,3.727-8.08.693-16.275,3.628-59.66,5.557-78.558C204.118,213.26,182.368,176.059,157.93,173.866Z",
    transform: "translate(-34.208 -96.825)",
    fill: "#fff",
    stroke: "#4b4e6d",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M197.331,250.3c.66-8.558,1.319-16.325,1.9-21.915.165-1.649.264-3.3.346-4.947l-39.427,6.6-33.87-11.543a187.627,187.627,0,0,0,1.187,20.975l33.227,9.3Z",
    transform: "translate(-33.208 -73.415)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M149.182,174.926c-2.243,2.49-6.695,7.552-10.933,12.928L163.281,213.3l8.245-3.3Z",
    transform: "translate(-26.927 -96.269)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M154.791,173.866s-14.841,16.045-20.431,26.021a50.608,50.608,0,0,0-4.007,9.531l29.847-34.48A28.036,28.036,0,0,0,154.791,173.866Z",
    transform: "translate(-31.069 -96.825)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M127.249,218.894l32.386,10.652,39.328-4.518a92.228,92.228,0,0,0-6.448-28.544L160.806,209.2,132.46,196.352a149.181,149.181,0,0,0-5.211,22.542Z",
    transform: "translate(-32.697 -85.029)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M184.255,268.143a100.275,100.275,0,0,1-49.041-4.007l-7.9-2.7-2.457,19.788,9,2.523a135.761,135.761,0,0,0,52.652,4.056l7.272-.874a6.6,6.6,0,0,0,.627-2.556c.2-4.4.544-10.8.989-18.139Z",
    transform: "translate(-33.951 -50.889)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M187.495,250.731a99.9,99.9,0,0,1-49.041-4.023L128.4,243.261a64.967,64.967,0,0,1-.148,10.784l-1.171,9.515,10.026,2.8a135.7,135.7,0,0,0,52.636,4.073l4.947-.594c.412-6.6.89-13.621,1.4-20.563Z",
    transform: "translate(-32.788 -60.421)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1230",
    "data-name": "Rectangle 1230",
    width: 40.911,
    height: 2.193,
    transform: "translate(31.884 146.212) rotate(-141.2)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M201.4,185.536s11.691,7.965,11.955,26.779c.115,8.245-.742,15.946-2.638,29.451s-13.67,57.484-22.838,62.826-23.4-4.749-23.4-4.749L95.652,254.15,79.013,240.711l-8.245-15.566,2.589-4.947,20.3,15.566L82.724,225.656l2.144-2.721,3.958,2.754,11.543,4.32,2.523,16.49,3.562,2.44L172.3,273s-.824-35.437-.214-42.214,1.451-23.811,8.707-36.162",
    transform: "translate(-62.326 -90.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(8.442 94.833)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M171.789,234.292c0,12.235.412,26.779.412,26.779l-65.778-23.96-3.562-2.44-2.523-16.49L88.8,213.861l-3.941-2.8-2.144,2.721,10.9,10.059-20.3-15.566-2.457,4.864L79.1,228.7l16.638,13.522,4.188,2.787,90.942,29.3Z",
    transform: "translate(-70.723 -173.61)",
    fill: "#09f",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M201.4,185.536s11.691,7.965,11.955,26.779c.115,8.245-.742,15.946-2.638,29.451s-13.67,57.484-22.838,62.826-23.4-4.749-23.4-4.749L95.652,254.15,79.013,240.711l-8.245-15.566,2.589-4.947,20.3,15.566L82.724,225.656l2.144-2.721,3.958,2.754,11.543,4.32,2.523,16.49,3.562,2.44L172.3,273s-.824-35.437-.214-42.214,1.451-23.811,8.707-36.162",
    transform: "translate(-62.326 -90.703)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M139.066,274.653,164.2,292.792l6.513-11.543s4.5-3.545,5.161-6.217-.181-7.008.495-9.68,4.04-5.178,4.353-11.642,0-11.856,0-11.856,5.442-22.377,4.848-32.106-9.976-26.928-17.5-27.307-17.3.759-24.883,12.235-6.035,44.984-7.223,47.078.462,12.433.462,12.433a5.788,5.788,0,0,0-2.309,4.172c-.132,2.688,2.77,9.3,2.77,9.3Z",
    transform: "translate(-29.096 -92.358)",
    fill: "#fff",
    stroke: "#4b4e6d",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M136.129,215.68a46.529,46.529,0,0,1-.643,8.591c-1.055,1.88.148,10.372.412,12.1a97.884,97.884,0,0,0,43.715,3.3,16.31,16.31,0,0,0,.561-3.512,118.532,118.532,0,0,0,0-11.856s.478-2,1.138-5.029A159.158,159.158,0,0,1,136.129,215.68Z",
    transform: "translate(-28.6 -74.89)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M140.922,191.647c-2.358,4.733-3.677,11.84-4.436,19.046a98.231,98.231,0,0,0,47.013,5.722,62.89,62.89,0,0,0,.841-11.543,32.123,32.123,0,0,0-2.144-8.9,163.02,163.02,0,0,1-41.274-4.32Z",
    transform: "translate(-27.852 -87.497)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M135.934,238.437l2.127,6.81,25.131,18.139,6.513-11.543s4.5-3.545,5.161-6.217a7.323,7.323,0,0,0,.214-1.418,153.669,153.669,0,0,1-39.147-5.771Z",
    transform: "translate(-28.141 -62.952)",
    fill: "#4b4e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M151.731,536.6s.561-14.28,3.3-35.156-3.842-50.525-4.947-55.472.561-15.929-.544-19.788-6.448-20.315-3.3-39.411,5.705-69.571,5.705-69.571-7.932-6.448-10.257-14.841-.544-11.032-.544-11.032",
    transform: "translate(-25.75 -35.206)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1.086
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_157",
    "data-name": "Line 157",
    x1: 3.051,
    y2: 16.886,
    transform: "translate(126.608 256.895)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1.086
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityAndLoginPhone);
export default __webpack_public_path__ + "static/media/security_and_login_phone.e2a0fc4c6f9c6fcc8df38dbc7fc24c64.svg";
export { ForwardRef as ReactComponent };